export const addFilterBikeParameter = (bikeId: string, shouldReload: boolean = false): void => {
    const url = new URL(window.location.href, window.location.origin);
    const existingBikeId = url.searchParams.get('filter_bike_id');

    if (existingBikeId === bikeId) {
        return;
    }

    url.searchParams.set('filter_bike_id', bikeId);
    history.replaceState({ path: url.toString() }, document.title, url.toString());

    if(shouldReload){
        window.location.reload();
    }
};

export const addProductConcreteFilterParameter = (sku: string): void => {
    const url = new URL(window.location.href, window.location.origin);
    const existingSku = url.searchParams.get('filter_article_number');

    if (existingSku === sku) {
        return;
    }

    url.searchParams.set('filter_article_number', sku);
    history.replaceState({ path: url.toString() }, document.title, url.toString());
};


export const updateRecommendationApiUrl = (recommendationApiUrl: string, sku: string): string => {
    //TODO: an empty sku is not normal case, it should be investigated!
    if (!sku) {
        return recommendationApiUrl;
    }

    const addToCardIdParam = sku;
    const skuList = addToCardIdParam.split('~');
    const productIdParam = skuList.length > 1 ? skuList[1] : skuList[0];

    const newRecommendationApiUrl =  new URL(recommendationApiUrl, window.location.origin);
    newRecommendationApiUrl.searchParams.set('addToCartId', addToCardIdParam);
    newRecommendationApiUrl.searchParams.set('productId', productIdParam);

    return newRecommendationApiUrl.toString();
}
